import React, { useCallback, useState } from 'react';
import { PAYMENT } from 'constants/shared/routes';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import MakePayment from '../presentational/MakePayment';
import useTranslate from 'lib/languages/useTranslate';
import { useGetPayeesQuery } from 'lib/services/payee';

const MakePaymentContainer = () => {
    const { data: payees, isFetching, error } = useGetPayeesQuery();

    const [active, setActive] = useState(false);
    const translate = useTranslate('managePayees');

    const ukClick = useCallback(() => {
        setActive(false);
    }, [setActive]);

    const intClick = useCallback(() => {
        setActive(true);
    }, [setActive]);

    return (
        <PageContainer className="manage-payee-container">
            <SectionTitle title={translate('title')} backRoute={PAYMENT} />
            <DataCheck
                data={payees}
                isLoading={isFetching}
                error={error}
                noDataMessage={translate('noDataMessage')}
            >
                <MakePayment
                    active={active}
                    ukClick={ukClick}
                    intClick={intClick}
                />
            </DataCheck>
        </PageContainer>
    );
};

export default MakePaymentContainer;
